import React from 'react';
import styles from './CheckoutCancelPage.module.css';

/**
 * CheckoutCancelPage — the Stripe Checkout cancel return (design Screen 3).
 *
 * Static, no API calls. Recovery-not-guilt framing: confirm nothing was charged
 * and offer a one-click path back to pricing. Real-estate-aware copy per design.
 *
 * @param {object} props
 * @param {() => void} [props.onSeePricing] - Navigate back to the pricing page.
 */
export default function CheckoutCancelPage({ onSeePricing }) {
  return (
    <div className={styles.page}>
      <div className={styles.card} data-testid="checkout-cancel">
        <h1 className={styles.title}>Checkout canceled — no charge made</h1>
        <p className={styles.message}>
          Buying a home is a big deal — take your time. Nothing was charged.
          Whenever you're ready, your plan is one click away.
        </p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primary}
            onClick={() => onSeePricing && onSeePricing()}
            data-testid="checkout-cancel-pricing"
          >
            See pricing again
          </button>
        </div>
      </div>
    </div>
  );
}
